module.exports = __webpack_public_path__ + "img/siteCondition.32db758e.png";